import { render } from "./assetcategorylist.vue?vue&type=template&id=203d7c7a"
import script from "./assetcategorylist.vue?vue&type=script&lang=js"
export * from "./assetcategorylist.vue?vue&type=script&lang=js"

import "./assetcategorylist.vue?vue&type=style&index=0&id=203d7c7a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__